class SupportUserMapper {
  static createModelFromResponse(response) {
    return {
      userId: response.user_id,
      externalId: response.external_id,
      isVip: response.is_vip,
      displayName: response.display_name
    };
  }
}

export { SupportUserMapper };
//# sourceMappingURL=SupportUserMapper.js.map
